/* 
Generated code: do not modify this file as it will be overwritten
Template: ImmutableJSRecord.cst

Known Issues/TODO:
- Using *Props type as Record constructor parameter is insufficient.
If a property needs to be a Record type, it should already be constructed.
- Rename Record fromJS factory method to fromJSON
- Create parseJSON method that translates JSON to Props



 */

/* eslint-disable import/order */

import { createSelector } from '@ngrx/store';
import { List, Map, Record, Seq, Set } from 'immutable';
import { AppState } from 'src/store/appstate';
import { getFromOrThrow, propValueOrDefault, tryOrDefault } from 'src/util/values';

export interface IdListItemProps {
  id: string;
}

export class IdListItemRecord extends Record<IdListItemProps>({
  id: null as any,
}) {
  public static fromJS(json: { id: string }): IdListItemRecord {
    if (json == null) {
      throw new Error('IdListItemRecord.fromJS: parameter cannot be null');
    }
    return new IdListItemRecord({
      id: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'id', '00000000-0000-0000-0000-000000000000'),
        'IdListItemJson.id',
      ),
    });
  }

  public static fromJSUnsafe(json: { id: string }): [IdListItemRecord, Error[]] {
    if (json == null) {
      throw new Error('IdListItemRecord.fromJSUnsafe: parameter cannot be null');
    }
    const errors: Error[] = [];

    const record = new IdListItemRecord({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      id: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'id', '00000000-0000-0000-0000-000000000000'),
            'IdListItemJson.id',
          ),
        (err) => errors.push(err),
      )!,
    });

    return [record, errors];
  }

  constructor(props: IdListItemProps) {
    super(props);
    if (props == null) {
      throw new Error('IdListItemRecord constructor parameter cannot be null');
    }
  }
}

export abstract class IdListItemViewModelBase implements IdListItemProps {
  protected readonly _props: IdListItemProps;
  private _json?: IdListItemProps;

  get id(): string {
    return this._props.id;
  }

  constructor(props: IdListItemProps) {
    this._props = props;
  }

  public toJS() {
    return this.toJSON();
  }

  public toJSON() {
    if (this._json == null) {
      this._json = {
        id: this._props.id,
      };
    }
    return this._json;
  }
}
